import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "firstLetter",
  standalone: false
})
export class FirstLetterPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return "";
    }

    if (value.charAt(0)) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }

    return value;
  }
}
